let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("grvAy")).then(() => parcelRequire('1xsEe'));